// extracted by mini-css-extract-plugin
module.exports =  {"contact":"_93444fe79c--contact--jVzBa","content":"_93444fe79c--content--o6ofY"};